import React from "react";
import PageElementWrapper from "./wrapPageElement";

const Wrapper = ({ element }) => {
  return <PageElementWrapper element={element} />;
};
export const wrapPageElement = Wrapper;
